/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LadderChallengeRules } from './LadderChallengeRules';
import {
    LadderChallengeRulesFromJSON,
    LadderChallengeRulesFromJSONTyped,
    LadderChallengeRulesToJSON,
    LadderChallengeRulesToJSONTyped,
} from './LadderChallengeRules';
import type { RankingSystem } from './RankingSystem';
import {
    RankingSystemFromJSON,
    RankingSystemFromJSONTyped,
    RankingSystemToJSON,
    RankingSystemToJSONTyped,
} from './RankingSystem';
import type { CompetitionFaq } from './CompetitionFaq';
import {
    CompetitionFaqFromJSON,
    CompetitionFaqFromJSONTyped,
    CompetitionFaqToJSON,
    CompetitionFaqToJSONTyped,
} from './CompetitionFaq';
import type { GlobalFilterExclusion } from './GlobalFilterExclusion';
import {
    GlobalFilterExclusionFromJSON,
    GlobalFilterExclusionFromJSONTyped,
    GlobalFilterExclusionToJSON,
    GlobalFilterExclusionToJSONTyped,
} from './GlobalFilterExclusion';
import type { LadderStatus } from './LadderStatus';
import {
    LadderStatusFromJSON,
    LadderStatusFromJSONTyped,
    LadderStatusToJSON,
    LadderStatusToJSONTyped,
} from './LadderStatus';
import type { LadderRatingConfig } from './LadderRatingConfig';
import {
    LadderRatingConfigFromJSON,
    LadderRatingConfigFromJSONTyped,
    LadderRatingConfigToJSON,
    LadderRatingConfigToJSONTyped,
} from './LadderRatingConfig';
import type { MatchScoringMode } from './MatchScoringMode';
import {
    MatchScoringModeFromJSON,
    MatchScoringModeFromJSONTyped,
    MatchScoringModeToJSON,
    MatchScoringModeToJSONTyped,
} from './MatchScoringMode';
import type { LadderActivityRules } from './LadderActivityRules';
import {
    LadderActivityRulesFromJSON,
    LadderActivityRulesFromJSONTyped,
    LadderActivityRulesToJSON,
    LadderActivityRulesToJSONTyped,
} from './LadderActivityRules';
import type { MatchFormat } from './MatchFormat';
import {
    MatchFormatFromJSON,
    MatchFormatFromJSONTyped,
    MatchFormatToJSON,
    MatchFormatToJSONTyped,
} from './MatchFormat';

/**
 * Ongoing ranked competition with challenge-based play
 * @export
 * @interface Ladder
 */
export interface Ladder {
    /**
     * 
     * @type {string}
     * @memberof Ladder
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof Ladder
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof Ladder
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof Ladder
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Ladder
     */
    description?: string;
    /**
     * ID of the OWGame
     * @type {string}
     * @memberof Ladder
     */
    gameId?: string;
    /**
     * ID of the MatchMode
     * @type {string}
     * @memberof Ladder
     */
    matchModeId?: string;
    /**
     * ID of the RuleSet
     * @type {string}
     * @memberof Ladder
     */
    ruleSetId?: string;
    /**
     * ID of the sponsoring Brand
     * @type {string}
     * @memberof Ladder
     */
    sponsorId?: string;
    /**
     * ID of the ScoringTemplate for EVENT_PIPELINE scoring
     * @type {string}
     * @memberof Ladder
     */
    scoringTemplateId?: string;
    /**
     * 
     * @type {RankingSystem}
     * @memberof Ladder
     */
    rankingSystem: RankingSystem;
    /**
     * 
     * @type {MatchFormat}
     * @memberof Ladder
     */
    matchFormat: MatchFormat;
    /**
     * 
     * @type {MatchScoringMode}
     * @memberof Ladder
     */
    scoringMode: MatchScoringMode;
    /**
     * 
     * @type {LadderRatingConfig}
     * @memberof Ladder
     */
    ratingConfig?: LadderRatingConfig;
    /**
     * 
     * @type {LadderChallengeRules}
     * @memberof Ladder
     */
    challengeRules?: LadderChallengeRules;
    /**
     * 
     * @type {LadderActivityRules}
     * @memberof Ladder
     */
    activityRules?: LadderActivityRules;
    /**
     * 1 for solo, 2+ for teams
     * @type {number}
     * @memberof Ladder
     */
    teamSize: number;
    /**
     * 
     * @type {number}
     * @memberof Ladder
     */
    maxParticipants?: number;
    /**
     * 
     * @type {number}
     * @memberof Ladder
     */
    minRatingToJoin?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Ladder
     */
    requiresApproval: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Ladder
     */
    isSeasonBased: boolean;
    /**
     * 
     * @type {number}
     * @memberof Ladder
     */
    seasonEndDate?: number;
    /**
     * Total participant count
     * @type {number}
     * @memberof Ladder
     */
    standingsCount: number;
    /**
     * 
     * @type {LadderStatus}
     * @memberof Ladder
     */
    status: LadderStatus;
    /**
     * 
     * @type {number}
     * @memberof Ladder
     */
    entryFee?: number;
    /**
     * 
     * @type {number}
     * @memberof Ladder
     */
    collectedPrizePool?: number;
    /**
     * ID of the payout table
     * @type {string}
     * @memberof Ladder
     */
    payoutTableId?: string;
    /**
     * 
     * @type {number}
     * @memberof Ladder
     */
    minParticipants?: number;
    /**
     * Cheat-filtering match-bracketing gate — requires active Match Start / Round Start in Redis to score
     * @type {boolean}
     * @memberof Ladder
     */
    requireActiveMatch?: boolean;
    /**
     * odId of the creator
     * @type {string}
     * @memberof Ladder
     */
    createdBy: string;
    /**
     * ID of the parent Competition
     * @type {string}
     * @memberof Ladder
     */
    competitionId?: string;
    /**
     * 
     * @type {Array<CompetitionFaq>}
     * @memberof Ladder
     */
    faqs?: Array<CompetitionFaq>;
    /**
     * IDs of EventPipelineFilter documents applied to this ladder's events
     * @type {Array<string>}
     * @memberof Ladder
     */
    appliedFilterIds?: Array<string>;
    /**
     * Break-glass per-entity exclusions of GLOBAL filters for this ladder (PRODUCT_PLAN D2(b)). Each entry names one global filter this ladder opts out of, with a required reason; with no end date the skip lasts for the life of the entity. Evaluated as set membership against the blocking lines stamped on the fan-out message.
     * @type {Array<GlobalFilterExclusion>}
     * @memberof Ladder
     */
    excludedGlobalFilters?: Array<GlobalFilterExclusion>;
    /**
     * Rule 4 opt-out. When true this ladder still scores events whose match context is missing (the pre-Rule-4 behavior). Default false — a ladder that declares what counts should not score events that cannot prove they qualify.
     * @type {boolean}
     * @memberof Ladder
     */
    failOpenOnMissingContext?: boolean;
}



/**
 * Check if a given object implements the Ladder interface.
 */
export function instanceOfLadder(value: object): value is Ladder {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('rankingSystem' in value) || value['rankingSystem'] === undefined) return false;
    if (!('matchFormat' in value) || value['matchFormat'] === undefined) return false;
    if (!('scoringMode' in value) || value['scoringMode'] === undefined) return false;
    if (!('teamSize' in value) || value['teamSize'] === undefined) return false;
    if (!('requiresApproval' in value) || value['requiresApproval'] === undefined) return false;
    if (!('isSeasonBased' in value) || value['isSeasonBased'] === undefined) return false;
    if (!('standingsCount' in value) || value['standingsCount'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    return true;
}

export function LadderFromJSON(json: any): Ladder {
    return LadderFromJSONTyped(json, false);
}

export function LadderFromJSONTyped(json: any, ignoreDiscriminator: boolean): Ladder {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'matchModeId': json['matchModeId'] == null ? undefined : json['matchModeId'],
        'ruleSetId': json['ruleSetId'] == null ? undefined : json['ruleSetId'],
        'sponsorId': json['sponsorId'] == null ? undefined : json['sponsorId'],
        'scoringTemplateId': json['scoringTemplateId'] == null ? undefined : json['scoringTemplateId'],
        'rankingSystem': RankingSystemFromJSON(json['rankingSystem']),
        'matchFormat': MatchFormatFromJSON(json['matchFormat']),
        'scoringMode': MatchScoringModeFromJSON(json['scoringMode']),
        'ratingConfig': json['ratingConfig'] == null ? undefined : LadderRatingConfigFromJSON(json['ratingConfig']),
        'challengeRules': json['challengeRules'] == null ? undefined : LadderChallengeRulesFromJSON(json['challengeRules']),
        'activityRules': json['activityRules'] == null ? undefined : LadderActivityRulesFromJSON(json['activityRules']),
        'teamSize': json['teamSize'],
        'maxParticipants': json['maxParticipants'] == null ? undefined : json['maxParticipants'],
        'minRatingToJoin': json['minRatingToJoin'] == null ? undefined : json['minRatingToJoin'],
        'requiresApproval': json['requiresApproval'],
        'isSeasonBased': json['isSeasonBased'],
        'seasonEndDate': json['seasonEndDate'] == null ? undefined : json['seasonEndDate'],
        'standingsCount': json['standingsCount'],
        'status': LadderStatusFromJSON(json['status']),
        'entryFee': json['entryFee'] == null ? undefined : json['entryFee'],
        'collectedPrizePool': json['collectedPrizePool'] == null ? undefined : json['collectedPrizePool'],
        'payoutTableId': json['payoutTableId'] == null ? undefined : json['payoutTableId'],
        'minParticipants': json['minParticipants'] == null ? undefined : json['minParticipants'],
        'requireActiveMatch': json['requireActiveMatch'] == null ? undefined : json['requireActiveMatch'],
        'createdBy': json['createdBy'],
        'competitionId': json['competitionId'] == null ? undefined : json['competitionId'],
        'faqs': json['faqs'] == null ? undefined : ((json['faqs'] as Array<any>).map(CompetitionFaqFromJSON)),
        'appliedFilterIds': json['appliedFilterIds'] == null ? undefined : json['appliedFilterIds'],
        'excludedGlobalFilters': json['excludedGlobalFilters'] == null ? undefined : ((json['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionFromJSON)),
        'failOpenOnMissingContext': json['failOpenOnMissingContext'] == null ? undefined : json['failOpenOnMissingContext'],
    };
}

export function LadderToJSON(json: any): Ladder {
    return LadderToJSONTyped(json, false);
}

export function LadderToJSONTyped(value?: Ladder | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'name': value['name'],
        'description': value['description'],
        'gameId': value['gameId'],
        'matchModeId': value['matchModeId'],
        'ruleSetId': value['ruleSetId'],
        'sponsorId': value['sponsorId'],
        'scoringTemplateId': value['scoringTemplateId'],
        'rankingSystem': RankingSystemToJSON(value['rankingSystem']),
        'matchFormat': MatchFormatToJSON(value['matchFormat']),
        'scoringMode': MatchScoringModeToJSON(value['scoringMode']),
        'ratingConfig': LadderRatingConfigToJSON(value['ratingConfig']),
        'challengeRules': LadderChallengeRulesToJSON(value['challengeRules']),
        'activityRules': LadderActivityRulesToJSON(value['activityRules']),
        'teamSize': value['teamSize'],
        'maxParticipants': value['maxParticipants'],
        'minRatingToJoin': value['minRatingToJoin'],
        'requiresApproval': value['requiresApproval'],
        'isSeasonBased': value['isSeasonBased'],
        'seasonEndDate': value['seasonEndDate'],
        'standingsCount': value['standingsCount'],
        'status': LadderStatusToJSON(value['status']),
        'entryFee': value['entryFee'],
        'collectedPrizePool': value['collectedPrizePool'],
        'payoutTableId': value['payoutTableId'],
        'minParticipants': value['minParticipants'],
        'requireActiveMatch': value['requireActiveMatch'],
        'createdBy': value['createdBy'],
        'competitionId': value['competitionId'],
        'faqs': value['faqs'] == null ? undefined : ((value['faqs'] as Array<any>).map(CompetitionFaqToJSON)),
        'appliedFilterIds': value['appliedFilterIds'],
        'excludedGlobalFilters': value['excludedGlobalFilters'] == null ? undefined : ((value['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionToJSON)),
        'failOpenOnMissingContext': value['failOpenOnMissingContext'],
    };
}

